import {
  faAdd,
  faPencil,
  faRotateExclamation,
  faTrash
} from '@fortawesome/pro-regular-svg-icons';

import type { SearchableSelectConfig } from '@/components/SearchableSelect';
import PERMISSIONS from '@/constants/auth.constants';
import { PRODUCTS } from '@/constants/products.constants';

import { type Organization, OrganizationType } from './Organizations.types';

export const PRODUCT_EXPIRATION_WARNING_PERIOD = 45;

export const PRODUCT_TYPES_TO_PULL = [
  PRODUCTS.EDR,
  PRODUCTS.LOG,
  PRODUCTS.LOG_USER,
  PRODUCTS.MCSC,
  PRODUCTS.NET,
  PRODUCTS.RET,
  PRODUCTS.VMP,
  PRODUCTS.VMPE,
  PRODUCTS.LOG_KANATI,
  PRODUCTS.WRNTY
];

export const ALL_ORGANIZATIONS: Organization = {
  id: 0,
  active_products: 0,
  is_auto_soc: 0,
  is_ir: false,
  is_restricted: false,
  label: 'all',
  name: 'All Organizations',
  product_status: 'Active',
  product_type: [],
  product_sub_type: [],
  total_users: 0,
  uid: '',
  webhook_url_ct: '',
  type: OrganizationType.SALESFORCE
};

// this organization is used for initialization of the page until organizations are fetched
export const NOOP_ORGANIZATION: Organization = {
  active_products: 0,
  id: -1,
  is_auto_soc: 0,
  is_ir: false,
  is_restricted: false,
  label: 'noop',
  name: 'No OP Organizations',
  product_status: 'Active',
  product_sub_type: [],
  product_type: [],
  total_users: 0,
  type: OrganizationType.SALESFORCE,
  uid: '',
  webhook_url_ct: ''
};

export const ORGANIZATIONS_QUICK_FILTERS: SearchableSelectConfig[] = [
  {
    field: 'product_status',
    title: 'Status',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'buttongroup'
    },
    filterOptions: []
  },
  {
    field: 'product_type',
    title: 'Product Type',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'product_sub_type',
    title: 'Product Sub Type',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'is_restricted',
    title: 'Restricted',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'toggle'
    },
    filterOptions: []
  },
  {
    field: 'ai_enabled',
    title: 'AI Enabled',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  }
];

export const ORGANIZATIONS_CONTEXT_MENU_ITEMS = [
  {
    label: 'Edit',
    icon: faPencil,
    permission: PERMISSIONS.ORGANIZATIONS_UPDATE
  },
  {
    label: 'Synchronize Organization',
    icon: faRotateExclamation,
    permission: PERMISSIONS.ORGANIZATIONS_UPDATE
  },
  {
    label: 'Clean Up Organization',
    icon: faRotateExclamation,
    permission: PERMISSIONS.ORGANIZATIONS_UPDATE
  },
  {
    label: 'Delete',
    icon: faTrash,
    permission: PERMISSIONS.ORGANIZATIONS_DELETE
  }
];

export const ORGANIZATIONS_CONTEXT_MENU_ITEMS_IR = [
  ...ORGANIZATIONS_CONTEXT_MENU_ITEMS,
  {
    label: 'Add Product',
    icon: faAdd,
    permission: PERMISSIONS.ORGANIZATIONS_UPDATE
  }
];

export default ORGANIZATIONS_QUICK_FILTERS;
